'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var hqoTheme = require('./hqo-theme-79db6cc8.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
var index$1 = require('./index-c3c373ce.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
var statusIndicator = require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var checkboxHqo = require('./checkbox-hqo-d946369c.js');

var StyledCheckbox = styled__default(checkboxHqo.CheckboxHqo)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  align-self: flex-start;\n  padding: 0;\n"], ["\n  align-self: flex-start;\n  padding: 0;\n"])));
var IconContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-right: 7px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-right: 7px;\n"])));
var StyledText = styled__default.p(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 14px/22px ", ";\n  font-style: normal;\n  font-weight: normal;\n  align-self: flex-start;\n  margin: 0;\n"], ["\n  font: 14px/22px ", ";\n  font-style: normal;\n  font-weight: normal;\n  align-self: flex-start;\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return (theme.fonts.join());
});
var StyledMenuItem = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  min-height: 38px;\n  padding: 8px 16px;\n  margin-bottom: 8px;\n  width: 100%;\n  overflow: hidden;\n  font: 14px ", ";\n  font-weight: normal;\n  font-style: normal;\n  line-height: 22px;\n  background-color: ", ";\n  ", "\n  ", "\n\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  &.focused {\n    background-color: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  min-height: 38px;\n  padding: 8px 16px;\n  margin-bottom: 8px;\n  width: 100%;\n  overflow: hidden;\n  font: 14px ", ";\n  font-weight: normal;\n  font-style: normal;\n  line-height: 22px;\n  background-color: ", ";\n  ", "\n  ", "\n\n  &:hover {\n    cursor: pointer;\n    background-color: ",
    ";\n  }\n\n  &.focused {\n    background-color: ", ";\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (theme.fonts.join());
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected && theme.colorsRgba.primary_1;
}, function (_a) {
    var readOnly = _a.readOnly;
    return readOnly && 'cursor: not-allowed;';
}, function (_a) {
    var withStatus = _a.withStatus;
    return withStatus && 'gap: 4px;';
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return (selected && theme.colorsRgba.primary_1)
        || theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return hqoTheme.rrggbbaa(theme.colors.floorPlan.blue, 0.1);
});
var MenuItem = function (_a) {
    var _b;
    var storedValue = _a.storedValue, label = _a.label, value = _a.value, icon = _a.icon, onChange = _a.onChange, isSelected = _a.isSelected, showCheckBox = _a.showCheckBox, readOnly = _a.readOnly, _c = _a.withStatus, withStatus = _c === void 0 ? false : _c;
    var itemClassName = ("item-" + value).replace(' ', '-');
    var menuItemClassName = index$1.classnames('menu-item', (_b = {
            'read-only': readOnly,
            selected: isSelected
        },
        _b[itemClassName] = value,
        _b));
    var handleMenuItemClick = React.useCallback(function (event) {
        event.stopPropagation();
        event.preventDefault();
        if (onChange && !readOnly) {
            onChange(storedValue, !isSelected);
        }
    }, [isSelected, onChange, readOnly, storedValue]);
    return (React__default.createElement(StyledMenuItem, { selected: isSelected, className: menuItemClassName, "data-cy": label + "-Menu-Item", "data-testid": label + "-Menu-Item", key: label + "-Menu-Item", onClick: handleMenuItemClick, readOnly: readOnly, withStatus: withStatus },
        showCheckBox && (React__default.createElement(StyledCheckbox, { "data-cy": label + "-Menu-Item-Checkbox", "data-testid": label + "-Menu-Item-Checkbox", checked: isSelected, disabled: readOnly })),
        icon && React__default.createElement(IconContainer, null, icon),
        withStatus ? (React__default.createElement(statusIndicator.StatusIndicator, { label: label, color: storedValue === null || storedValue === void 0 ? void 0 : storedValue.indicatorColor, variant: storedValue === null || storedValue === void 0 ? void 0 : storedValue.indicatorVariant, version: storedValue === null || storedValue === void 0 ? void 0 : storedValue.version })) : (React__default.createElement(StyledText, { className: itemClassName }, label))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.MenuItem = MenuItem;
